export function safeReturnPath(value, origin) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return null;
  if (/[\\\x00-\x20\x7f]/.test(value)) return null;
  try {
    const decoded = decodeURIComponent(value);
    if (decoded.startsWith('//') || /[\\\x00-\x20\x7f]/.test(decoded)) return null;
    const target = new URL(value, origin);
    if (target.origin !== origin || target.username || target.password) return null;
    if (/^\/(([\w-]+)\/)?(login|signup|callback|forgot-password|reset-password|verify-email|accept-invite)(\/|$)/.test(target.pathname)) return null;
    return target.pathname + target.search + target.hash;
  } catch {
    return null;
  }
}
